"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLaunchbees = exports.useFlags = exports.LaunchbeesProvider = void 0;
var react_1 = __importStar(require("react"));
var LaunchbeesContext = (0, react_1.createContext)(null);
var LaunchbeesProvider = function (_a) {
    var launchbees = _a.launchbees, config = _a.config, children = _a.children;
    var firstRenderRef = (0, react_1.useRef)(true);
    if (firstRenderRef.current) {
        firstRenderRef.current = false;
        launchbees.init(config);
    }
    return (react_1.default.createElement(LaunchbeesContext.Provider, { value: launchbees }, children));
};
exports.LaunchbeesProvider = LaunchbeesProvider;
var getRenderKey = function (lb, flags) {
    return flags
        .map(function (flag) {
        return "".concat(flag).concat(lb.hasFeature(flag));
    }).join(',');
};
function useFlags(flags) {
    var firstRenderRef = (0, react_1.useRef)(true);
    var launchbees = (0, react_1.useContext)(LaunchbeesContext);
    var _a = (0, react_1.useState)(getRenderKey(launchbees, flags)), renderKey = _a[0], setRenderKey = _a[1];
    var renderRef = (0, react_1.useRef)(renderKey);
    var eventListener = (0, react_1.useCallback)(function () {
        var newRenderKey = getRenderKey(launchbees, flags);
        if (newRenderKey !== renderRef.current) {
            renderRef.current = newRenderKey;
            setRenderKey(newRenderKey);
        }
    }, []);
    if (firstRenderRef.current) {
        firstRenderRef.current = false;
        document.addEventListener("lb_flags_changed", eventListener);
    }
    var res = (0, react_1.useMemo)(function () {
        var res = {};
        flags.map(function (featureKey) {
            res[featureKey] = {
                isEnabled: launchbees.hasFeature(featureKey),
                featureKey: featureKey
            };
        });
        return res;
    }, [renderKey]);
    return res;
}
exports.useFlags = useFlags;
function useLaunchbees() {
    var context = (0, react_1.useContext)(LaunchbeesContext);
    if (!context) {
        throw new Error('hook can only be used inside LaunchbeesProvider');
    }
    return context;
}
exports.useLaunchbees = useLaunchbees;
